export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  const pfx = 'emp-clock';
  const style = `<style>
    .${pfx} {
     height: 15%;
     width: 20%;
    } 
    .${pfx}-container {
     width: 100%;
    }
    .${pfx}-container-header {
    color: #fff;
    padding: 6px;
    font-family: Helvetica;
    }
    .${pfx}-container-content {
     display: flex;
     flex-direction: row;
     height: 100%;
    justify-content: center;
    }
    .${pfx}-container-time-current {
      padding-left: 0.4em;
      padding-right: 0.4em;
    } 
    .${pfx}-container-date-current {
      display: flex;
      flex-direction: column;
      padding-left: 0.6em;
      justify-content: center;
      font-family: sans-serif;
    }
   
  </style>`;
  bm.add('Clock', {
    label: 'Clock',
    category: 'Widget',
    content: `<div data-gjs-type="clocks" ></div>
        ${style}
      `,
    attributes: {
      class: 'fa fa-clock-o', //icon in the panel,
    },
  });
};



// WEBPACK FOOTER //
// ./src/plugins/clock/blocks.js